"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnlockApply = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var ButtonPrim_1 = require("components/Buttons/ButtonPrim");
var Money_1 = __importDefault(require("components/Money"));
var Text_1 = __importDefault(require("shared/components/Text"));
var backend_1 = require("utils/backend");
var stylesUnlock_1 = require("./stylesUnlock");
var UnlockApply = function (_a) {
    var _b = _a.deal, _c = _b.service, serviceId = _c.id, name = _c.name, dealKey = _b.key, deal = __rest(_b, ["service", "key"]);
    var _d = __read((0, react_1.useState)({}), 2), form = _d[0], setForm = _d[1];
    var fs = function (k, v) { return function (e) { return setForm(function (s) {
        var _a;
        return (__assign(__assign({}, s), (_a = {}, _a[k] = v || e.target.value, _a)));
    }); }; };
    var onSubmit = function (e) {
        e.preventDefault();
        return (0, backend_1.callBackendFn)('companies-claimDeal', { serviceId: serviceId, dealKey: dealKey, dealUpdate: __assign(__assign({}, form), { status: 'applied' }) });
    };
    return ((0, jsx_runtime_1.jsx)(stylesUnlock_1.Root, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 2 }, { children: (0, jsx_runtime_1.jsxs)("form", __assign({ autoComplete: "off", onSubmit: onSubmit }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: stylesUnlock_1.classes.amount }, { children: "Instructions" })), (0, jsx_runtime_1.jsxs)("p", { children: ["Answer these two questions and hit the ", (0, jsx_runtime_1.jsx)("b", { children: "apply" }), " button."] }), (0, jsx_runtime_1.jsxs)("p", { children: ["How many people will be using this tool?", (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mt: 1 }, { children: [(0, jsx_runtime_1.jsx)("input", { name: "uc", type: "text", required: true, value: form.userCount, className: stylesUnlock_1.classes.hidden }), (0, jsx_runtime_1.jsx)(material_1.ButtonGroup, __assign({ size: "small", "aria-label": "small outlined button group" }, { children: ['Just me', '2-10', '11-30', '>30'].map(function (opt) { return ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({ onClick: fs('userCount', opt), disabled: form.userCount === opt }, { children: opt }), opt)); }) }))] }))] }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(material_1.TextareaAutosize, { required: true, value: form.reasonWant, onChange: fs('reasonWant'), className: stylesUnlock_1.classes.textarea, minRows: 2, placeholder: "What's the main reason you want to use ".concat(name) }) })] }), (0, jsx_runtime_1.jsxs)(ButtonPrim_1.ButtonPinkLgN, __assign({ disabled: !form.userCount || !form.reasonWant, type: "submit", className: stylesUnlock_1.classes.button }, { children: ["Apply for ", (0, jsx_runtime_1.jsx)(Money_1.default, { amount: deal.dealValueEstimate })] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 1 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: "*We will forward this to the vendor on your behalf and contact you shortly" })) }))] })) })) }));
};
exports.UnlockApply = UnlockApply;
